import { PAIR_LESSONS_PLUSES_LIST } from '@/page-content/pair-lessons/constants/pluses-list';
import { Article } from '@/shared/components/article';
import { TextPlusesList } from '@/shared/components/text-pluses-list';
export const PlusesPairLessons = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Плюсы парных занятий по английскому</h2>

      <TextPlusesList items={PAIR_LESSONS_PLUSES_LIST} />
    </Article>;
};